import { render, staticRenderFns } from "./SaveMoney.vue?vue&type=template&id=019ed46f&scoped=true&"
import script from "./SaveMoney.vue?vue&type=script&lang=js&"
export * from "./SaveMoney.vue?vue&type=script&lang=js&"
import style0 from "./SaveMoney.vue?vue&type=style&index=0&id=019ed46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ed46f",
  null
  
)

export default component.exports